import { Box, HStack, Header, Icon, Image, Text } from '@rbilabs/universal-components';

import Link from 'components/link';
import { SAFE_AREA_TOP_INSET } from 'components/modal/constants';

import theme from './theme';

export const InnerText = Text.withConfig({
  color: theme.innerColor,
  lineHeight: theme.innerLineHeight,
});

export const HeaderContainer = Box.withConfig({
  minHeight: 250 + SAFE_AREA_TOP_INSET,
});

export const InnerHeader = Header.withConfig({
  color: Styles.color.black,
  textTransform: 'capitalize',
  lineHeight: 'lg',
  variant: 'headerTwo',
  focusable: true,
  marginTop: '$4',
});

export const Address = Text.withConfig({
  color: theme.addressColor,
  fontSize: 'md',
  textTransform: 'capitalize',
  lineHeight: 'md',
  marginY: '$1',
});

export const Amenity = HStack.withConfig({
  marginBottom: '$3.5',
  alignItems: 'center',
});

export const AmenityIcon = Icon.withConfig({
  marginRight: '$1.5',
  width: '$8',
});

export const SpacingLine = Box.withConfig({
  borderStyle: 'solid',
  borderTopWidth: '1px',
  borderTopColor: 'rgba(177, 177, 177, 0.7)',
});

export const StoreHourContainer = HStack.withConfig({
  marginY: '$2',
  justifyContent: 'space-between',
});

export const FeatureIcon = Image.withConfig({
  marginRight: '$1',
  height: '$6',
  width: '$8',
});

export const PhoneNumber = Link.withConfig({
  color: theme.phoneNumberColor,
  fontSize: 'md',
  fontWeight: '400',
  isInline: true,
  isUnderlined: true,
});
